import { useState, useCallback, useEffect } from 'react'

const useToggle = (defaultOpen = true) => {
  const [isOpen, setState] = useState(defaultOpen)

  useEffect(() => {
    setState(false)
  }, [])

  const toggle = useCallback(() => setState(!isOpen), [isOpen])

  const onClick = useCallback(
    evt => {
      if (evt) evt.preventDefault()

      toggle()
    },
    [toggle]
  )

  return [isOpen, onClick]
}

export default useToggle
